import Communities from './Communities/Communities'
import withAEM from '../../hoc/withAEM'

const ReactCommunities = (props: any): JSX.Element => {
  const ReactCommunitiesWithAEM = withAEM(Communities)
  return <ReactCommunitiesWithAEM {...props} compName={'React Communities'} />
}
export default ReactCommunities
